const AgedDebtorReport = () => {
  return (
    <p>
      This should be a list of invoices you have issued but are yet to be paid,
      and ideally grouped by the number of days outstanding e.g. (30, 60, 90+
      days).{' '}
      <a
        href="https://gocardless.com/guides/posts/aged-debtors-report/"
        target="_blank"
        rel="noreferrer"
      >
        Learn more
      </a>
    </p>
  );
};

export default AgedDebtorReport;
